import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { AcademicYearApi } from "../../../api/academic-year/academic-year.api";
import { dateToView } from "../../../utils/date.utils";
import { PaymentChannelsApi } from "../../../api/payment-channels/payment-channels.api";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();

    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("");


    const [data, setData] = useState<any[]>([{}]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);

    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 300, sortable: false, disablePadding: false, align: 'center', label: t("MANAGE_PAYMENT_PAYMENT_NAME")
        },
        {
            id: "subject_name", disablePadding: false, width: 240, align: "center", label: t("MANAGE_PAYMENT_ACCOUNT_NAME_TH")
        },
        {
            id: "subject_name", disablePadding: false, width: 240, align: "center", label: t("MANAGE_PAYMENT_ACCOUNT_NAME_EN")
        },
        {
            id: "subject_name", disablePadding: false, width: 200, align: "center", label: t("MANAGE_PAYMENT_ACCOUNT_NUMBER")
        },
        {
            id: "subject_name", disablePadding: false, width: 200, align: "center", label: t("MANAGE_PAYMENT_ACCOUNT_TYPE")
        },
        {
            id: "subject_name", disablePadding: false, width: 240, align: "center", label: t("MANAGE_PAYMENT_CREATED_UPDATED_BY")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 240, label: t("MANAGE_PAYMENT_CREATED_UPDATED_DATE")
        },


        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 180, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            account_name_th,
            created_by,
            account_name_eng,
            modified_date,
            payment_channels_type,
            id_payment_channels,
            account_no,
            account_type,
            modified_by

        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "left", label: payment_channels_type || "-" },

                {
                    option: "TEXT",
                    align: "center",
                    label: account_name_th || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: account_name_eng || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: account_no || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: account_type || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || created_by || "-",
                },


                {
                    option: "TEXT",
                    align: "center",
                    label: dateToView(modified_date) || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        {/* <IconButton onClick={() => navigate(routeName.admission.applicants_detail)}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
                        <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => navigate(routeName.admission.ManagePaymentView?.replace(':id',id_payment_channels))}
                            onEditClick={() => navigate(routeName.admission.ManagePaymentDetail?.replace(':id',id_payment_channels))}
                            onDeleteClick={() => handleDeleteList(id_payment_channels)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteList = (id_payment_channels: number) => {
            alertActive(t("MANAGE_PAYMENT_DELETE"), t("MANAGE_PAYMENT_CONFIRM_DELETE"), undefined, undefined, async () => {
                dispatch(setLoading());
                await PaymentChannelsApi.deletePaymentChannel(id_payment_channels).then((res) => {
                    if (res.status < 300) {
                        alertSuccess(t("MANAGE_PAYMENT_DELETE"), t("MANAGE_PAYMENT_DELETE_COMPLETED"))
                        handleGetData();
                    }
                }).catch((err) => {
                    console.log(err)
                    alertError(t("MANAGE_PAYMENT_DELETE"), t("MANAGE_PAYMENT_DELETE_FAILED"))
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            })
        }

    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, search: keyword }
        // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await PaymentChannelsApi.getPaymentChannelList(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate])

    useEffect(() => {
        handleGetData()
    },[handleGetData])


    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,

    }
}

export default ManageState